export default __webpack_public_path__ + "static/media/face.2b45e8a6.png";